jQuery(document).ready(function ($) {
    // Флаг, який вказує, чи вже відбувалася обробка події focus
    let hasFocused = false;

    // Відслідковуємо подію натискання на поле вводу
    if (!hasFocused) {
        $('.search_input').on('focus', function () {
            // Перевіряємо, чи подія focus відбулася вперше
            handleInput();
            hasFocused = true; // Позначаємо, що подія focus відбулася
        });
    }

    // Відслідковуємо подію зміни значення інпута
    $('.search_input').on('input', function () {
        handleInput();
    });

    // Функція, яка буде виконуватися при натисканні на поле вводу або зміні його значення
    function handleInput() {
        // Отримуємо значення інпута
        const inputValue = $('.search_input').val().trim();
        const searchList = document.getElementById('search-list');
        searchList.style.display = 'block';

        // Відправляємо асинхронний запит на сервер
        $.ajax({
            url: ajax_search.ajax_url,
            type: 'post',
            data: {
                action: 'load_more_search',
                search_value: inputValue,
                lang: main?.current_lang
            },
            success: function (response) {
                // Оновлюємо контент іншого елементу, де виводиться результат
                $('.search-list').html(response);
            },
        });
    }

});
